import styled from "styled-components";

export const AlertMessageBox = styled.div`
  gap: 20px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  svg {
    path {
      fill: #16baa4;
    }
  }
`;

export const AlertMessageText = styled.p`
  gap: 8px;
  color: ${(props) => props.theme.colors.black60};
  display: flex;
  font-size: 16px;
  text-align: center;
  line-height: 120%;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.black60};
    font-weight: 600;
  }
`;

export const Highlight = styled.span`
  color: ${(props) => props.theme.colors.black80} !important;
  font-size: 20px;
  font-weight: 900;
  text-shadow: 0.2px 0 currentColor, -0.2px 0 currentColor, 0 0.2px currentColor,
    0 -0.2px currentColor;
`;

export const BtnHighlight = styled.span`
  text-decoration: underline;
`;
